export const PRODUCTS_CATALOG_BLOK: string = 'products-catalog';
